import React, { useState, useEffect } from 'react';
import Cards from 'react-credit-cards';
import { Link, useHistory } from 'react-router-dom'

import UIkit from 'uikit';
import MDUIkit from 'md-uikit';

import Cleave from 'cleave.js/react';
import Header from './header_cart';
import Footer from './footer';

import DeniedImg from "../../assets/img/close_icon.png"
import cards from "../../assets/img/cards.JPG"
import PCILogo from "../../assets/img/pci-logo.png"
import verifySSL from "../../assets/img/verify_ssl.png"

import UserActions from '../../providers/user/user.actions';

import 'react-credit-cards/lib/styles.scss';
import Logo from '../../assets/img/main_logo.png'
import { config } from '../../settings.js';

const PaymentScreen = () => {
    const [confirmationDetails, setConfirmationDetails] = useState([]);

    const user = UserActions();
    const history = useHistory();
    useEffect(() => {
        MDUIkit.components();
        if (!user.currentUser) {
            history.push("./");
        }
        window.scrollTo(0,0);
        /* cart.cartItems */
        console.log();
    }, []);
    return (
        <>
            {user.currentUser &&
                <>
                    < div className="uk-container">
                        <div className="uk-padding">

                            <div className="uk-card uk-card-body md-bg-white" align="center">
                                <img src={Logo} width="180px" />
                                <h3 className="md-color-red-500">Pago rechazado</h3>
                                <img width='50px' src={DeniedImg} alt="" />
                                <h5>{user.currentUser.name + " " + user.currentUser.lastname}</h5>
                                <p>Tu pago no pudo ser procesado, porfavor intentalo nuevamente o utiliza otro medio de pago.</p>
                                <button onClick={() => history.goBack()} className="md-btn md-btn-outlined md-btn-primary md-btn-wave-light "><i className='material-icons'>keyboard_arrow_left</i> Regresar</button>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            }
        </>
    );
}

export default PaymentScreen;
